var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",staticStyle:{"background-color":"#13255d !important"}},[_c('ServicePlaceAddStepper',{on:{"Saved":_vm.SavedEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }